



























































































import Vue from "vue";
import { Logo, Profile, Room, ScreenEvent } from "../../interfaces";
import {
  createMultipleOccurenceEvent,
  getAvailableLogos,
  getAvailableRooms,
  getProfile,
} from "../../services";
import EventDisplay from "../EventDisplay.vue";

interface Data {
  rooms: Room[];
  logos: Logo[];
  dateMenu: boolean;
  startMenu: boolean;
  endMenu: boolean;
  titleRules: ((any) => boolean | string)[];
  dateRules: ((any) => boolean | string)[];
}

interface Props {
  event: ScreenEvent;
  reset: boolean;
}

export default Vue.extend<Data, any, any, Props>({
  components: {
    EventDisplay,
  },
  props: {
    event: {},
    reset: {}
  },
  computed: {
    timeValidation() {
      return this.validateTime();
    }
  },
  watch: {
      reset: function(reset: boolean) {
          if (reset) {
              this.dates = [];
              (this.$refs.form as any).resetValidation();
          }
      }
  },
  data: () => ({
    rooms: [] as Room[],
    logos: [] as Logo[],
    titleRules: [(v) => !!v || "Titel muss angegeben werden"],
    dateRules: [(v) => !!v || "Datum muss angegeben werden"],
    tendRules: [(v) => !!v || "Ende muss angegeben werden"],
    tstartRules: [(v) => !!v || "Start muss angegeben werden"],
    dateMenu: false,
    startMenu: false,
    dates: [] as any[],
    endMenu: false,
    profile: {} as Profile,
  }),
  created: async function () {
    this.profile = await getProfile();
    await this.fetchData();
  },
  methods: {
    validateTime() {
      const tend = (this.event as any).tend;
      const tstart = (this.event as any).tstart;
      if (tstart && tend && tstart >= tend) {
        return ["Start muss vor Ende sein"];
      }
      return [];
    },
    async fetchData() {
      this.rooms = await getAvailableRooms();
      this.logos = await getAvailableLogos();
    },
    closeDialog() {
      this.$emit("close");
      (this.$refs.form as any).reset();
    },
    async save() {
      if (!(this.$refs.form as any).validate() || !this.dates.length || this.validateTime().length) {
        return;
      }
      const event = this.event as ScreenEvent;
      const success = await createMultipleOccurenceEvent({
          title: event.title,
          tstart: event.tstart,
          tend: event.tend,
          room: event.room?.id,
          logo: event.logo?.id,
          dates: this.dates
      });
      if (success) {
        this.$emit("close", true);
      }
    },
  },
});
